{
  "adaptation.title": "Plan adaptation",
  "adaptation.lede": "Record what changed, inspect recurring friction, and deliberately move work without losing the reason or trade-off.",
  "adaptation.error.generic": "The planning change could not be completed.",
  "adaptation.filter.from": "From",
  "adaptation.filter.to": "To",
  "adaptation.report.title": "Friction summary",
  "adaptation.report.description": "Factual counts from the selected period—no score, diagnosis, or judgement.",
  "adaptation.report.total": "Recorded deviations",
  "adaptation.report.unresolved": "Awaiting a decision",
  "adaptation.report.causes": "Most recorded circumstances",
  "adaptation.report.repeats": "Repeated subjects",
  "adaptation.report.empty": "Not enough records in this period.",
  "adaptation.dayRevision.title": "Absorb a changed day",
  "adaptation.dayRevision.description": "When available time disappeared but individual blocks should remain untouched, record the deficit as one reviewed day revision.",
  "adaptation.dayRevision.deficit": "Minutes no longer available",
  "adaptation.dayRevision.preview": "Preview revision",
  "adaptation.dayRevision.apply": "Apply revision",
  "adaptation.dayRevision.confirmTitle": "Apply this day revision?",
  "adaptation.dayRevision.confirmDescription": "Record {{minutes}} minutes of lost capacity and preserve the stated reason in the replanning history.",
  "adaptation.dayRevision.previewResult": "Preview complete: {{minutes}} minutes would be absorbed. No records changed.",
  "adaptation.dayRevision.appliedResult": "Day revised: {{minutes}} minutes were absorbed and the decision was recorded.",
  "adaptation.deviations.title": "Plan deviations",
  "adaptation.deviations.description": "Capture the difference between the plan and what happened, then decide what to do with it.",
  "adaptation.deviations.emptyTitle": "No deviations recorded",
  "adaptation.deviations.emptyDescription": "There is nothing to resolve in this date range.",
  "adaptation.sessions.title": "Replanning sessions",
  "adaptation.sessions.description": "Keep the situation, considered changes, trade-offs, and final decision together.",
  "adaptation.replan.title": "Move work with context",
  "adaptation.replan.description": "Inspect candidate days in date order. Exognitos shows capacity and protection; you choose the trade-off.",
  "adaptation.replan.slot": "{{free}} min free · {{committed}} min committed",
  "adaptation.replan.protected": "Protected time",
  "adaptation.replan.fits": "Fits available time",
  "adaptation.replan.doesNotFit": "Exceeds available time",
  "adaptation.edit.title": "Correct this record",
  "adaptation.resolve.title": "Record your decision",
  "adaptation.adjustment.title": "Add a considered adjustment",
  "adaptation.close.title": "Close this replanning session",
  "adaptation.session.open": "Open",
  "adaptation.session.closed": "Closed",
  "adaptation.session.adjustmentCount": "Recorded adjustments: {{count}}",
  "adaptation.deleteDeviation.title": "Permanently delete this deviation?",
  "adaptation.deleteDeviation.description": "This removes the historical record and cannot be undone.",
  "adaptation.deleteSession.title": "Permanently delete this replanning session?",
  "adaptation.deleteSession.description": "The session and its adjustment history will be removed and cannot be recovered.",
  "adaptation.action.record": "Record deviation",
  "adaptation.action.review": "Review and resolve",
  "adaptation.action.save": "Save correction",
  "adaptation.action.resolve": "Record decision",
  "adaptation.action.delete": "Delete permanently",
  "adaptation.action.showOptions": "Show days",
  "adaptation.action.applyMove": "Move to this day",
  "adaptation.action.startSession": "Start session",
  "adaptation.action.open": "Open session",
  "adaptation.action.addAdjustment": "Add adjustment",
  "adaptation.action.closeSession": "Close session",
  "adaptation.field.day": "Day",
  "adaptation.field.task": "Task",
  "adaptation.field.noTask": "No linked task",
  "adaptation.field.chooseTask": "Choose an open task",
  "adaptation.field.kind": "What changed",
  "adaptation.field.cause": "Circumstance",
  "adaptation.field.note": "What happened",
  "adaptation.field.actualMinutes": "Actual minutes",
  "adaptation.field.resolution": "Decision",
  "adaptation.field.resolutionNote": "Decision note",
  "adaptation.field.horizon": "Days to inspect",
  "adaptation.field.reason": "Reason for this change",
  "adaptation.field.tradedAway": "What this displaces or gives up",
  "adaptation.field.overrideProtection": "Override protected time",
  "adaptation.field.overrideProtectionHint": "Use only when you deliberately accept the protected-time conflict.",
  "adaptation.field.trigger": "Why you are replanning",
  "adaptation.field.situation": "Current situation",
  "adaptation.field.adjustmentKind": "Adjustment type",
  "adaptation.field.subjectLabel": "What was considered",
  "adaptation.field.verdict": "Final decision",
  "adaptation.kind.never_started": "Never started",
  "adaptation.kind.started_not_finished": "Started, not finished",
  "adaptation.kind.overran": "Took longer than planned",
  "adaptation.kind.underran": "Took less time than planned",
  "adaptation.kind.displaced": "Something else took the time",
  "adaptation.kind.moved_early": "Moved before the day",
  "adaptation.kind.done_elsewhere": "Done outside the planned slot",
  "adaptation.kind.deliberately_skipped": "Skipped deliberately",
  "adaptation.cause.not_recorded": "Not recorded",
  "adaptation.cause.energy": "Not enough energy",
  "adaptation.cause.sleep": "Sleep",
  "adaptation.cause.health": "Health",
  "adaptation.cause.mood": "Emotional state",
  "adaptation.cause.motivation": "Could not want to",
  "adaptation.cause.competing_work": "Other work took the time",
  "adaptation.cause.external_demand": "Someone else needed the time",
  "adaptation.cause.social_pull": "Chose people over the plan",
  "adaptation.cause.interruption": "Interruption",
  "adaptation.cause.wrong_environment": "Wrong environment",
  "adaptation.cause.missing_input": "A dependency was not ready",
  "adaptation.cause.unclear_next_step": "The next step was unclear",
  "adaptation.cause.underestimated": "The work was underestimated",
  "adaptation.cause.overpacked_day": "The day was overpacked",
  "adaptation.cause.impulse": "Followed an impulse",
  "adaptation.cause.lost_track_of_time": "Lost track of time",
  "adaptation.cause.travel": "Travel or time away",
  "adaptation.cause.changed_mind": "Changed mind",
  "adaptation.resolution.pending": "Not decided yet",
  "adaptation.resolution.rescheduled": "Rescheduled",
  "adaptation.resolution.rescoped": "Made smaller and kept",
  "adaptation.resolution.delegated_to_minimum": "Reduced to a minimum version",
  "adaptation.resolution.dropped": "Dropped",
  "adaptation.resolution.absorbed": "Left where it was",
  "adaptation.resolution.escalated": "Needs broader replanning",
  "adaptation.trigger.day_collapsed": "The day changed significantly",
  "adaptation.trigger.day_close": "Closing the day",
  "adaptation.trigger.capacity_changed": "Available time changed",
  "adaptation.trigger.new_commitment": "A new commitment arrived",
  "adaptation.trigger.period_slipped": "A period slipped",
  "adaptation.trigger.routine_review": "Reviewing a routine",
  "adaptation.trigger.periodic": "Regular replanning",
  "adaptation.trigger.assistant": "Started with an assistant",
  "adaptation.adjustment.nothing": "Considered and left unchanged",
  "adaptation.adjustment.block_moved": "Schedule block moved",
  "adaptation.adjustment.block_removed": "Schedule block removed",
  "adaptation.adjustment.block_created": "Schedule block created",
  "adaptation.adjustment.task_deferred": "Task deferred",
  "adaptation.adjustment.task_estimate_changed": "Task estimate changed",
  "adaptation.adjustment.task_canceled": "Task cancelled",
  "adaptation.adjustment.task_skipped": "Routine occurrence skipped",
  "adaptation.adjustment.task_priority_changed": "Task priority changed",
  "adaptation.adjustment.routine_paused": "Routine paused",
  "adaptation.adjustment.period_moved": "Period moved",
  "adaptation.adjustment.period_extended": "Period extended",
  "adaptation.adjustment.period_status_changed": "Period status changed",
  "adaptation.adjustment.checkpoint_moved": "Checkpoint moved"
}
